var React = require('react');

function POS (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"POS"),React.createElement("g",{"id":"g1483","key":2},[React.createElement("path",{"id":"path1618-3-5-6","className":"cls-1","d":"M88.24,28H39.76V78H88.24Z","key":0}),React.createElement("path",{"id":"path1652-6-9-9-8","className":"cls-1","d":"M64,119V78","key":1}),React.createElement("path",{"id":"path1652-6-9-9","className":"cls-1","d":"M64,28V9","key":2})]),React.createElement("path",{"id":"path1652-6-9-9-2","data-name":"path1652-6-9-9","className":"cls-1","d":"M104,53H88.65","key":3}),React.createElement("path",{"id":"path1652-6-9-9-3","data-name":"path1652-6-9-9","className":"cls-1","d":"M39.35,53H24","key":4})]);
}

POS.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = POS;

POS.default = POS;
